// extracted by mini-css-extract-plugin
module.exports = {"pagination":"GroupPagination_pagination__Fu9CJ","item":"GroupPagination_item__3TrMY","enabled":"GroupPagination_enabled__YOiDo"};